import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import DownloadIcon from '@mui/icons-material/Download';
import { APIContext } from '../../Contexts/APIContext';
import { useContext } from 'react';

interface ReportOption {
    name: string;
    camelCaseName: string;
}

const reportOptions: ReportOption[] = [
    { name: "Licence Codes", camelCaseName: "licenceCodes" },
    { name: "Membership CSV Export", camelCaseName: "membershipCsvExport" },
    { name: "Member Report", camelCaseName: "memberReport" },
    { name: "30 Days Since Licence Expiry", camelCaseName: "thirtyDaysSinceLicenceExpiry" },
    { name: "60 Days Since Licence Expiry", camelCaseName: "sixtyDaysSinceLicenceExpiry" }
];

interface IProps {
    open: boolean;
    onClose: () => void;
}

export default function CalendarExportsDialog({ open, onClose }: IProps) {
    const { getCSV } = useContext(APIContext);

    const getReport = (reportName: string) => {
        getCSV('CalendarCSV', `GetReport?reportName=${reportName}`, reportName);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Choose Export</DialogTitle>
            <DialogContent>
                <Grid container sx={{ mt: 1 }}>
                    {reportOptions.map((option) => (
                        <Grid size={12} key={option.camelCaseName}>
                            <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<DownloadIcon />}
                                onClick={() => getReport(option.camelCaseName)}
                                sx={{
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    py: 1.5
                                }}
                            >
                                {option.name}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}